import { Component, Input } from '@angular/core';
import { Links } from '../../models/links.model';

@Component({
  selector: 'app-links-card',
  templateUrl: './links-card.component.html',
  styleUrls: ['./links-card.component.scss'],
})
export class LinksCard {
  @Input() links: Links[];
}
